import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export function RegisterPage() {
  const [form, setForm] = useState({
    fullName:   '',
    email:      '',
    password:   '',
    tenantSlug: 'demo-school',
  });
  const [loading, setLoading] = useState(false);
  const { register }          = useAuth();
  const navigate              = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await register(form);
      toast.success('Account created! Welcome to EduNex 🎉');
      navigate('/dashboard');
    } catch (error: any) {
      const msg = error.response?.data?.message
               || error.response?.data?.fields?.email
               || 'Registration failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center
                    bg-gray-950 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-black mb-2">
            <span className="text-green-400">Edu</span>
            <span className="text-white">Nex</span>
          </h1>
          <p className="text-gray-400 text-sm">Create your account</p>
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8">
          <h2 className="text-xl font-bold text-white mb-6">Register</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {[
              { name: 'fullName',   label: 'Full Name',    type: 'text',     placeholder: 'Arjun Sharma' },
              { name: 'email',      label: 'Email',        type: 'email',    placeholder: 'arjun@school.com' },
              { name: 'password',   label: 'Password',     type: 'password', placeholder: 'Min 8 chars, uppercase, number' },
              { name: 'tenantSlug', label: 'School Slug',  type: 'text',     placeholder: 'demo-school' },
            ].map(field => (
              <div key={field.name}>
                <label className="block text-sm text-gray-400 mb-1">
                  {field.label}
                </label>
                <input
                  type={field.type}
                  name={field.name}
                  value={(form as any)[field.name]}
                  onChange={handleChange}
                  required
                  placeholder={field.placeholder}
                  className="w-full bg-gray-800 border border-gray-700
                             rounded-lg px-4 py-3 text-white text-sm
                             focus:outline-none focus:border-green-400
                             transition-colors"
                />
              </div>
            ))}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-green-400 text-gray-950 font-bold
                         py-3 rounded-lg hover:bg-green-300
                         transition-colors disabled:opacity-50"
            >
              {loading ? 'Creating account...' : 'Create Account'}
            </button>
          </form>

          <p className="text-center text-gray-500 text-sm mt-6">
            Have an account?{' '}
            <Link to="/login" className="text-green-400 hover:text-green-300">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}